module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Bold.a123e4ed.woff";